import React from 'react';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import CountdownTimer from './components/CountdownTimer';
import OurStory from './components/OurStory';
import EventDetails from './components/EventDetails';
import WeddingParty from './components/WeddingParty';
import Gallery from './components/Gallery';
import RsvpForm from './components/RsvpForm';
import GiftWishes from './components/GiftWishes';
import Footer from './components/Footer';
export function App() {
  return <div className="font-sans text-gray-800 bg-ivory" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <CountdownTimer data-id="element-3" />
      <OurStory data-id="element-4" />
      <EventDetails data-id="element-5" />
      <WeddingParty data-id="element-6" />
      <Gallery data-id="element-7" />
      <RsvpForm data-id="element-8" />
      <GiftWishes data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}